import { UX2 } from '@wsb/guac-widget-core';
const { Color } = UX2.utils;

export const WHITE_COLOR = new Color('rgba(255,255,255,1)');
export const BLACK_COLOR = new Color('rgba(0,0,0,1)');
export const LIVID_COLOR = new Color('rgba(69,90,100,1)');
export const ERROR_COLOR = new Color('#ff0000');
export const DARK_BORDER = new Color('rgba(0, 0, 0, 0.3)');
export const LIGHT_BORDER = new Color('rgba(255, 255, 255, 0.3)');
